<span class="status-author-handle {isStatusInNotification ? 'status-in-notification' : '' }">
  {'@' + originalAccount.acct}
</span>
<style>
  .status-author-handle {
    grid-area: author-handle;
    align-self: center;
    margin-left: 5px;
    color: var(--deemphasized-text-color);
    font-size: 1.1em;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .status-author-handle.status-in-notification {
    color: var(--very-deemphasized-text-color);
  }
</style>